import * as CONFIGS from "@/statics/configs.js";

const NODE11 = {
  NAME: "TS1C",
  INPUT1: {
    NAME: "NODE11_INPUT1_NAME",
    TYPE: "zeroContact",
    ICON: "switch",
    PARAMETER_ID: 0x8020,
  },
  AUTOENABLE1: {
    NAME: "NODE11_AUTOENABLE1_NAME",
    PARAMETER_ID: 0xE030,
  },
  OUTPUT1: {
    NAME: "NODE11_OUTPUT1_NAME",
    TYPE: "RelaySSR2A",
    ICON: "lamp",
    PARAMETER_ID: 0xe010,
  },
  LEDSTATE1: {
    NAME: "NODE11_LEDSTATE1_NAME",
    TYPE: "LED",
    ICON: "lamp",
    PARAMETER_ID: 0xE120,
  },
  TEMPERATURE: {
    NAME: "NODE11_TEMPERATURE_NAME",
    TYPE: "internalTemperature",
    ICON: "temperature",
    PARAMETER_ID: 0x8101,
  },
  NOTIFY_HUB: {
    PARAMETER_ID: 0x6100,
  },
  RELAY1_INIT: {
    PARAMETER_ID: 0xe110,
  },
  LORA_RSSI: {
    PARAMETER_ID: 0x8102,
  },
  LORA_SNR: {
    PARAMETER_ID: 0x8103,
  },
};
NODE11.DEFAULT_INSTRUCTIONS = [
  [
    {
      eventToWatch: {
        parameterId: NODE11.INPUT1.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE11.NOTIFY_HUB.PARAMETER_ID,
        valueOfChange: 0,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
  ],
];

export default NODE11;
